export interface ILink {
  name: string;
  url?: string;
  baseUrl?: string;
  networkTypes?: string[];
  externalUrl?: (isApt?: boolean) => string;
}

export interface ISubNavProps {
  in: boolean;
  links: (ILink | undefined)[];
}

export enum SUBNAV {
  USERS = "USERS",
  HELP = "HELP",
  REPORTS = "REPORTS",
  SETTINGS = "SETTINGS",
  SUPER_ADMIN = "SUPER_ADMIN",
}
